var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.rate)?_c('v-chip',{attrs:{"color":_vm.statusColor.bg}},[_c('span',{class:_vm.statusColor.text},[_vm._v(_vm._s(_vm.rate * 2 + ' / 10'))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }